
// common function to 
export const formatPageName = (name) => {
    var strPagename = "";
    strPagename = name.toLowerCase();
    // strPagename = fnReplaceSymbols(strPagename, "-", "");
    strPagename = fnReplaceSymbols(strPagename, " ", "-");
    strPagename = fnReplaceSymbols(strPagename, "'", "");
    strPagename = fnReplaceSymbols(strPagename, ".", "");
    strPagename = fnReplaceSymbols(strPagename, "/", "");
    strPagename = fnReplaceSymbols(strPagename, ":", "");
    strPagename = fnReplaceSymbols(strPagename, "\\", "");
    strPagename = fnReplaceSymbols(strPagename, "|", "");
    strPagename = fnReplaceSymbols(strPagename, "*", "");
    strPagename = fnReplaceSymbols(strPagename, "?", "");
    strPagename = fnReplaceSymbols(strPagename, "@", "");
    strPagename = fnReplaceSymbols(strPagename, "#", "");
    strPagename = fnReplaceSymbols(strPagename, "{", "");
    strPagename = fnReplaceSymbols(strPagename, "}", "");
    strPagename = fnReplaceSymbols(strPagename, ",", "");
    strPagename = fnReplaceSymbols(strPagename, "[", "");
    strPagename = fnReplaceSymbols(strPagename, "]", "");
    strPagename = fnReplaceSymbols(strPagename, "(", "");
    strPagename = fnReplaceSymbols(strPagename, ")", "");
    strPagename = fnReplaceSymbols(strPagename, "!", "");
    strPagename = fnReplaceSymbols(strPagename, "%", "");
    strPagename = fnReplaceSymbols(strPagename, "^", "");
    strPagename = fnReplaceSymbols(strPagename, "&", "");
    strPagename = fnReplaceSymbols(strPagename, "`", "");
    strPagename = fnReplaceSymbols(strPagename, "+", "");
    strPagename = fnReplaceSymbols(strPagename, "\"", "");
    strPagename = fnReplaceSymbols(strPagename, "~", "");
    strPagename = fnReplaceSymbols(strPagename, ";", "");
    strPagename = fnReplaceSymbols(strPagename, "<", "");
    strPagename = fnReplaceSymbols(strPagename, ">", "");
    strPagename = fnReplaceSymbols(strPagename, "--", "-");
    return strPagename
}

function fnReplaceSymbols(str, strSymbol, strReplace) {
    var strMain = str;
    for (var i = 0; i < str.length; i++) {
        if (strMain.indexOf(strSymbol) >= 0) strMain = strMain.replace(strSymbol, strReplace);
        else break;
    }
    return strMain;
}